import React from 'react'

interface ContactFormProps{
  isFormOpened: boolean,
  logoConstructora: string,
  colorsData: any,
  isContactModalOpened: boolean
}

const ContactFormMobile = ({isFormOpened, logoConstructora, colorsData, isContactModalOpened}: ContactFormProps) => {
  return(
    <div className={isFormOpened  && isContactModalOpened ? "contact-form-mobile fade-in":"contact-form-mobile fade-out"}>
      <div className='contact-from-logo-container'>
        <img src={"https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"+logoConstructora} alt=""></img>
      </div>
      <div className='contact-form-text-mobile'>Déjanos un mensaje y pronto te contactaremos</div>
      <div className='contact-form-input-container-mobile'>
        <input type={"text"} placeholder='Nombre'></input>
        <input type={"number"} placeholder='Teléfono'></input>
        <input type={"email"} placeholder='Correo eléctronico'></input>
        <textarea style={{resize: "none"}} placeholder='Mensaje'></textarea>
      </div>
      <div 
        className='contact-form-send-btn-mobile'
        style={{backgroundColor: colorsData ? colorsData.main_buttons:""}}
      >
        ENVIAR
      </div>
    </div>
  )
}

export default ContactFormMobile